import React, { useState, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";
import { BarChart3 } from "lucide-react";
import "../styles/VisitorStats.css";

const MonthlyVisitorStats = () => {
  const [monthlyVisits, setMonthlyVisits] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMonthlyVisits = async () => {
      try {
        const now = new Date();
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
          .toISOString()
          .split("T")[0];
        const lastDayOfMonth = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          0
        )
          .toISOString()
          .split("T")[0];

        const { data, error } = await supabase
          .from("page_visits")
          .select("visit_count")
          .eq("page_name", "home")
          .gte("visit_date", firstDayOfMonth)
          .lte("visit_date", lastDayOfMonth);

        if (error) {
          console.error("Error fetching monthly visits:", error);
          return;
        }

        const totalVisits =
          data?.reduce((sum, record) => sum + record.visit_count, 0) || 0;
        setMonthlyVisits(totalVisits);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMonthlyVisits();
    // Refresh data every 5 minutes
    const interval = setInterval(fetchMonthlyVisits, 300000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="visitor-stats-card">
      <div className="visitor-stats-content">
        {loading ? (
          <div className="visitor-stats-loading">Loading...</div>
        ) : (
          <div className="visitor-stats-count">{monthlyVisits}</div>
        )}
        <div className="visitor-stats-label">
          <BarChart3 size={20} />
          <span>Monthly Visitors</span>
        </div>
      </div>
    </div>
  );
};

export default MonthlyVisitorStats;
